import {api} from '../api';
import _ from 'lodash';
import {
    SPR_FILE_HISTORY_LOADED,
    NEW_FILE_UPLOADED,
    SPR_TASK_DELETED,
    SPR_TASK_STARTED,
    SPR_PRODUCTS_LOADED,
    SPR_PRODUCT_LOADED_BY_ID,
    SPR_MODEL_BASIC_VALUE_CHANGE,
    SPR_MODEL_DESCRIPTION_VALUE_CHANGE,
    SPR_MODEL_DATASHEET_VALUE_CHANGE
} from './types';

export const fetchSprProducts = (jwt, query) => (dispatch) => {
    return api.ecommerce.getSprProducts(jwt, query).then(res => {
        dispatch({
            type: SPR_PRODUCTS_LOADED,
            payload: res.data.data
        })
        return res;
    }).catch(err => {
        throw err;
    })
}

export const fetchSprProductById = (jwt, id) => (dispatch) => {
    return api.ecommerce.getSprByProductId(jwt, id).then(res => {
        dispatch({
            type: SPR_PRODUCT_LOADED_BY_ID,
            payload: res.data.data
        })
        return res;
    }).catch(err => {
        throw err;
    })
}

export const setSprProductModel = (model) => {
    return {
        type: SPR_PRODUCT_LOADED_BY_ID,
        payload: model
    }
}

export const fetchUploadHistory = (jwt) => (dispatch) => {
    return api.ecommerce.getSprHistory(jwt).then(res => {
        dispatch({
            type: SPR_FILE_HISTORY_LOADED,
            payload: res.data.data
        })
        return res;
    }).catch( err => {
        throw err
    })
}

export const onSprModelBasicFieldChange = (field, value) => {
    return {
        type: SPR_MODEL_BASIC_VALUE_CHANGE,
        payload: {field, value}
    }
}

export const onSprModelDescriptionChange = (index, value) => {
    return {
        type: SPR_MODEL_DESCRIPTION_VALUE_CHANGE,
        payload: {index, value}
    }
}

export const onSprModelDataSheetChange = (key, index, value) => {
    return {
        type: SPR_MODEL_DATASHEET_VALUE_CHANGE,
        payload: {key, index, value}
    }
}

export const newFileUploaded = (data) => {
    return {
        type: NEW_FILE_UPLOADED,
        payload: data
    }
}

export const sprTaskRemoved = (index) => {
    return {
        type: SPR_TASK_DELETED,
        payload: index
    }
}

export const sprTaskStarted = (index, newTask) => {
    return {
        type: SPR_TASK_STARTED,
        payload: {
            index, newTask
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/ecommerce.js